import { StrapiProfileFormInterface } from '@/types/strapiProfileForm.interface';
import axios from 'axios';

export async function getProfileForm(host: string, lang: string) {
  const response = await axios.get(`https://${host}/profile-forms`, {
    params: { lang },
  });
  return response.data as StrapiProfileFormInterface[];
}
